import _ from 'lodash';
import * as THREE from 'three';
import { tjsLight } from './tjsLight';

export class tjsStage {
  _initData;
  _mixins;
  _scene;
  _lights;
  _camera;
  _rotation;
  _position;
  _scale;
  _controlsOptions;
  _startProp;
  _fov;
  _near;
  _canvas;

  constructor(initData, mixin) {
    this._initData = initData;
    this._mixins = mixin;
    this._lights = [];
    this._rotation = this.getPosition({ x: 0, y: 0, z: 0 }, initData.rotation);
    this._position = this.getPosition({ x: 0, y: 0, z: 0 }, initData.positions);
    this._scale = this.getPosition({ x: 1, y: 1, z: 1 }, initData.scale);
    this._near = this._isNumber(initData.near) == true ? initData.near : false;
    this._fov = this._isNumber(initData.fov) == true ? initData.fov : false;
    this._controlsOptions = _.mapKeys(initData.controlsOptions, function (value, key) {
      return _.toString(key);
    });

    this._startProp = {
      camera: false,
      fov: false,
    };
  }

  getPosition(sPosition, tPosition) {
    if (typeof tPosition != 'undefined' && tPosition != null) {
      let self = this;
      return _.mergeWith(sPosition, tPosition, function (value, key) {
        if (self._isNumber(key) == true) {
          return Number(key);
        }
        return Number(value);
      });
    }
    return sPosition;
  }

  beforeDestroy() {
    console.log('BEFORE DESTROY');
  }

  createLights() {
    if (Array.isArray(this._initData.lights) !== true) {
      let light1 = new tjsLight(null, null, { x: 200, y: 350, z: 250 }),
        light2 = new tjsLight(null, 0.5);
      this._lights.push(
        new tjsLight(null, null, { x: 200, y: 350, z: 250 }).DirectionalLight(),
        new tjsLight(null, 0.5).AmbientLight()
      );
      return false;
    }

    for (let i in this._initData.lights) {
      let light = new tjsLight(
        this._initData.lights[i].color,
        this._initData.lights[i].intensity,
        this._initData.lights[i].position
      );

      switch (this._initData.lights[i].type) {
        case 'AmbientLight':
          this._lights.push(light.AmbientLight());
          continue;
        case 'DirectionalLight':
          this._lights.push(light.DirectionalLight());
          continue;
        case 'HemisphereLight':
          this._lights.push(
            light.HemisphereLight(this._initData.lights[i].skyColor, this._initData.lights[i].groundColor)
          );
          continue;
        case 'PointLight':
          this._lights.push(light.PointLight());
          continue;
        default:
          continue;
      }
    }
  }

  createCamera(width, height) {
    this._camera = new THREE.OrthographicCamera(
      width / -2, // left
      width / 2, // right
      height / 2, // top
      height / -2, // bottom
      1, // near
      100 // far
    );

    this._camera.position.set(4, 4, 4);
    this._camera.lookAt(0, 0, 0);
  }

  findIntersectObjects(e, canvas) {
    if (typeof canvas == 'undefined' || canvas == null) {
      canvas = this.canvas;
    }
    if (typeof this.world.camera == 'undefined' || this.world.camera == null) {
      return;
    }

    const rect = canvas.getBoundingClientRect();
    let raycaster = new THREE.Raycaster();
    let p = new THREE.Vector2(
      ((e.clientX - rect.left) * canvas.width) / rect.width,
      ((e.clientY - rect.top) * canvas.height) / rect.height
    );
    let mouse = new THREE.Vector2((p.x / canvas.width) * 2 - 1, (p.y / canvas.height) * -2 + 1);

    raycaster.setFromCamera(mouse, this.world.camera);

    return raycaster.intersectObjects(this.world.wrapper.children[0].children);
  }

  _isNumber(n) {
    n = Number(n);
    if (Number.isNaN(n) == true || Number.isFinite(n) == false) {
      return false;
    }

    return true;
  }

  get rotation() {
    return this._rotation;
  }
  get position() {
    return this._position;
  }
  get scale() {
    return this._scale;
  }
  get near() {
    return this._near;
  }
  get fov() {
    return this._fov;
  }

  get lights() {
    return this._lights;
  }
  get controlsOptions() {
    return this._controlsOptions;
  }
  set controlsOptions(v) {
    this._controlsOptions = v;
  }
  get canvas() {
    return this._canvas;
  }
  set canvas(v) {
    this._canvas = v;
  }
}

export class tjsStageVUE extends tjsStage {
  _whiteMask;
  _cameraPosition;
  _cameraRotation;
  _speedRotation;
  _rotating;
  _world;

  constructor(initData, mixin) {
    super(initData, mixin);

    this._whiteMask = new THREE.TextureLoader().load(
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='
    );
    this._cameraPosition = this.getPosition({ x: 0, y: 0, z: 0 }, initData.cameraPosition);
    this._cameraRotation = this.getPosition({ x: 0, y: 0, z: 0 }, initData.cameraRotation);
    this._speedRotation = this.getPosition({ x: 0, y: 0, z: 0 }, initData.speedRotation);

    this._rotating = false;
    this._world = {};
  }

  setWorld(world) {
    this._world = world;

    this._world.scale = _.merge(this._world.scale, this._scale);
    this._world.position = _.merge(this._world.position, this._position);
    this._world.rotation = _.merge(this._world.rotation, this._rotation);

    if (typeof this._world.camera == 'undefined' || this._world.camera == null) {
      this._world.camera = this._camera;
    }
    this._world.camera.rotation = _.merge(this._world.camera.rotation, this._cameraRotation);
    this._world.camera.position = _.merge(this._world.camera.position, this._cameraPosition);
    this._world.cameraPosition = _.merge(this._world.cameraPosition, this._cameraPosition);

    if (this._near === false) {
      this._near = _.cloneDeep(this._world.camera.near);
    } else {
      this._world.camera.near = this._near;
    }
    if (this._fov === false) {
      this._fov = _.cloneDeep(this._world.camera.fov);
    } else {
      this._world.camera.fov = this._fov;
    }

    this._world.camera.lookAt(world.position);
    this._world.camera.updateMatrixWorld();
    console.log(this._world);
  }

  rotate() {
    if (this.rotating === true && typeof this.world != 'undefined') {
      this.world.rotation.x += this.speedRotation.z;
      this.world.rotation.y += this.speedRotation.y;
      this.world.rotation.z += this.speedRotation.z;
    }
  }

  reset() {
    this.setWorld(this._world);
  }

  get whiteMask() {
    return this._whiteMask;
  }
  get speedRotation() {
    return this._speedRotation;
  }

  get worldPositino() {
    if (typeof this._world == 'undefined' || this._world == null) {
      return this._position;
    }
    return this._world.position;
  }

  get worldRotation() {
    if (typeof this._world == 'undefined' || this._world == null) {
      return this._rotation;
    }
    return this._world.rotation;
  }

  get cameraPosition() {
    if (typeof this._world.camera == 'undefined' || this._world.camera == null) {
      return this._cameraPosition;
    }
    return this._world.camera.position;
  }

  set cameraPosition(v) {
    if (typeof this._world.camera != 'undefined' && this._world.camera != null) {
      this._world.camera.position = v;
    }
  }

  get cameraRotation() {
    if (typeof this._world.camera == 'undefined' || this._world.camera == null) {
      return this._cameraRotation;
    }
    return this._world.camera.rotation;
  }

  set cameraRotation(v) {
    if (typeof this._world.camera != 'undefined' && this._world.camera != null) {
      this._world.camera.rotation = v;
    }
  }

  get rotating() {
    return this._rotating;
  }
  set rotating(v) {
    this._rotating = v;
  }
  get world() {
    return this._world;
  }
  set world(v) {
    this._world = v;
  }
}
